import { useRef, useState, DragEvent, ChangeEvent } from 'react';
import { UploadUnfiledIcon } from '../../../../assets/icons';
import styles from './InputFile.module.scss'

interface InputFileProps {
    onChange?: (file: File | null) => void;
}

const InputFile = ({ onChange }: InputFileProps) => {
    const [file, setFile] = useState<File | null>(null);
    const [isDragging, setIsDragging] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);

    const handleFile = (incoming: File | null) => {
        setFile(incoming);
        onChange?.(incoming);
    };

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const selected = e.target.files?.[0] ?? null;
        handleFile(selected);
    };

    const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDrop = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsDragging(false);
        const dropped = e.dataTransfer.files?.[0] ?? null;
        if (dropped) handleFile(dropped);
    };

    const handleRemove = () => {
        handleFile(null);
        if (inputRef.current) inputRef.current.value = '';
    };

    return (
        <div
            className={`${styles.inputContainer} ${isDragging ? styles.dragging : ''}`}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
        >
            {file ? (
                <div className={styles.filePreview}>
                    <span className={styles.fileName}>{file.name}</span>
                    <button type='button' className={styles.removeBtn} onClick={handleRemove}>Remove</button>
                </div>
            ) : (
                <>
                    <div className={styles.iconWrapper}>
                        <UploadUnfiledIcon />
                    </div>
                    <p className={styles.mainText}>Choose a file or drag & drop it here.</p>
                    <p className={styles.subText}>XLSX Format only</p>
                    <label className={styles.browseBtn}>
                        Browse File
                        <input
                            ref={inputRef}
                            type='file'
                            accept='.xlsx'
                            hidden
                            onChange={handleChange}
                        />
                    </label>
                </>
            )}
        </div>
    );
}

export default InputFile;
